import { DashboardCard, MediaImagesIcon, imageOutlineSx } from '@nexus/ari-lib';

import { Box, Typography } from '@mui/material';

// ----------------------------------------------------------------------

export type MediaItem = {
  id: number;
  src: string;
  duration?: string;
};

type DashboardMediaSectionProps = {
  items: MediaItem[];
  onClick?: () => void;
  comingSoon?: boolean;
};

export function DashboardMediaSection({ items, onClick, comingSoon = false }: DashboardMediaSectionProps) {
  return (
    <DashboardCard
      data-testid="cloud.dashboard.media-section"
      title="Media"
      subtitle="Photos and Videos"
      icon={<MediaImagesIcon sx={{ width: 28, height: 28 }} />}
      onClick={onClick}
      comingSoon={comingSoon}
    >
      {items.length === 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            gap: 1,
            color: 'text.secondary',
          }}
        >
          <MediaImagesIcon sx={{ width: 40, height: 40, opacity: 0.4 }} />
          <Typography variant="body2" sx={{ color: 'text.secondary', opacity: 0.4 }}>
            No media captured yet
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 0.5,
          }}
        >
          {items.map((item) => (
            <Box
              key={item.id}
              sx={{
                width: '100%',
                paddingTop: '100%',
                bgcolor: 'action.disabledBackground',
                borderRadius: 1,
                position: 'relative',
                overflow: 'hidden',
              }}
            >
              <Box
                component="img"
                src={item.src}
                alt="media"
                loading="lazy"
                width={120}
                height={120}
                sx={(theme) => ({
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  ...imageOutlineSx(theme),
                })}
              />
              {item.duration && (
                <Typography
                  variant="caption"
                  sx={{
                    position: 'absolute',
                    bottom: 3,
                    right: 5,
                    color: 'common.white',
                    fontSize: 10,
                    fontWeight: 600,
                    textShadow: '0 1px 2px rgba(0,0,0,0.6)',
                  }}
                >
                  {item.duration}
                </Typography>
              )}
            </Box>
          ))}
        </Box>
      )}
    </DashboardCard>
  );
}
